import { Spinner } from '../components/Spinner';

export default function LoadingPage() {
  return (
    <div className="center-content">
      <Spinner />
    </div>
  );
}
